<template>
  <TablePaginated
      label="Interests"
      sublabel="What interests your passengers the most?"
      :main-list="itemData"
      :is-global-percent="isGlobalPercent"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TablePaginated from '../../../TablePaginated.vue';

export default {
  name: 'PagedListInterests',
  components: {
    TablePaginated,
  },

  props: {
    itemData: {
      type: [Array],
      default() {
        return ([]);
      },
    },
  },

  computed: {
    ...mapGetters({
      isGlobalPercent: 'metrics/isGlobalPercent',
    }),
  },
};
</script>
